// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  width: 100%;
  height: 100%;
  --background: transparent;
  --height: 100%;
}

iframe {
  width: 100%;
  height: 100%;
}

.mobile-landscape-iframe {
  width: 100%;
  height: 1000px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/daily-slot/daily-slot.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,cAAA;AACF","sourcesContent":["body {\r\n  width: 100%;\r\n  height: 100%;\r\n  --background: transparent;\r\n  --height: 100%;\r\n}\r\n\r\niframe {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.mobile-landscape-iframe {\r\n  width: 100%;\r\n  height: 1000px;\r\n  overflow: auto;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
